import React from 'react'
import { Link } from 'react-router'

import classNames from './FooterMenu.css'
import Icon from '../Icon'

export default function FooterMenu ({ items }) {
  return (
    <ul className={classNames.menu}>
      {items.map(renderItem)}
    </ul>
  )
}

function renderItem ({ icon, size, onClick, href, shouldShow, disabled }) {
  if (typeof shouldShow !== 'undefined' && !shouldShow) {
    return null
  }
  const linkClassName = typeof disabled !== 'undefined' && disabled ? classNames.linkDisabled : classNames.link
  const itemClassName = icon === 'spinner' ? classNames.itemSpinner : classNames.item
  if (href) {
    return (
      <li key={icon} className={itemClassName}>
        <Link to={href} className={linkClassName}>
          <Icon icon={icon} size={size} />
        </Link>
      </li>
    )
  }
  return (
    <li key={icon} className={itemClassName}>
      <button onClick={onClick} className={linkClassName}>
        <Icon icon={icon} size={size} />
      </button>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/menu/FooterMenu.js